import React from 'react';
import { useSelector } from 'react-redux';
import { useLang } from '../../util/lang';
import useUpSellSmileDesignForm from '../../hooks/useUpSellSmileDesignForm';
import { FormProvider } from 'react-hook-form';
import loopSmileDesignQuestions from './LoopSmileDesignQuestions';

/** Renders the Upsell Smile Design prescription form. */
const UpSellSmileDesignPrescriptionNotes = ({ isMarieGroup = undefined, isTWGroup = undefined, isSEAGroup = undefined, schema }) => {
    const { config, formValues, methods } = useUpSellSmileDesignForm({
        isMarieGroup,
        isTWGroup,
        isSEAGroup,
        isUpSellTab: true,
        schema: schema,
    });
    const displayFirstFitFlag = useSelector((state) => state.globalReducer.displayFirstFitFlag);
    const get = useLang();
    return (
        <FormProvider {...methods}>
            <div style={{ marginBottom: 16 }}>
                {
                    displayFirstFitFlag && <span>{get('@PatientInfo.smileDesign.clinicalApprovement.Restoration.SectionOne')}</span>
                }
                <div className={displayFirstFitFlag ? "isd-prescription-radio-scope" : undefined}>{loopSmileDesignQuestions(config, formValues, false, get, true, displayFirstFitFlag)}</div>
            </div>
        </FormProvider>
    );
};

export default UpSellSmileDesignPrescriptionNotes;
